<template>
  <v-layout>
    <v-layout v-if="showTemplateDetail === false">
      <v-flex lg12 md12>
        <v-card dark>
          <v-toolbar flat>
            <v-toolbar-title>Create New Dashboard Template<sup><font size="2" color="#C17F3F" style="margin-top: 50px;"> BETA</font></sup></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="$emit('close')" icon>
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-progress-linear
            height="6px"
            style="margin: 0"
            :active="isLoading"
            :indeterminate="isLoading"
            absolute bottom
            color="deep-purple accent-4"
            />
          <v-subheader style="padding: 0px 24px;">Add Dashboard</v-subheader>
          <v-container grid-list-md fluid>
            <v-layout row wrap>
              <v-flex max-width="165px">
                <v-card flat tile>
                  <v-btn round @click="selectType('Compliance')" class="button-class">
                    <v-icon large dark>event_note</v-icon>
                  </v-btn>
                  <p>Compliance</p>
                </v-card>
              </v-flex>
              <v-flex max-width="165px">
                <v-card flat tile>
                  <v-btn round @click="selectType('Analytics')" class="button-class">
                    <v-icon large dark>show_chart</v-icon>
                  </v-btn>
                  <p>Analytics</p>
                </v-card>
              </v-flex>
              <v-flex max-width="165px">
                <v-card flat tile>
                  <v-btn round @click="selectType('Monitoring')" class="button-class">
                    <v-icon large dark>desktop_mac</v-icon>
                  </v-btn>
                  <p>Monitoring</p>
                </v-card>
              </v-flex>
              <v-flex max-width="165px">
                <v-card flat tile>
                  <v-btn round @click="selectType('Security')" class="button-class">
                    <v-icon large dark>security</v-icon>
                  </v-btn>
                  <p>Security</p>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
          <v-subheader style="padding: 0px 24px;">Custom</v-subheader>
          <v-container grid-list-md fluid>
            <v-layout row wrap align-start justify-end fill-height>
              <v-flex lg12 md12 class="text-md-left">
                <v-card flat tile>
                  <v-btn round @click="selectType('Advanced')" class="button-class">
                    <v-icon large dark>settings</v-icon>
                  </v-btn>
                <p style="padding-left: 25px">Advanced</p>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-else>
      <v-layout v-if="type === 'Advanced'">
        <v-flex lg12 md12>
          <v-form
            ref="form"
            v-model="validForm"
            lazy-validation
          >
            <v-card dark>
              <v-toolbar flat>
                <v-btn @click.native="back()" icon>
                  <v-icon>arrow_back</v-icon>
                </v-btn>
                <v-toolbar-title>Advanced</v-toolbar-title>
              </v-toolbar>
              <v-progress-linear
                height="6px"
                style="margin: 0"
                :active="isLoading"
                :indeterminate="isLoading"
                absolute bottom
                color="deep-purple accent-4"
                />
              <v-subheader style="padding: 0px 24px;">Select Visualization Add Your Template</v-subheader>
              <v-container grid-list-md fluid>
                <v-layout row warp>
                  <v-flex lg12 md12>
                    <v-text-field
                      v-model="templateName"
                      :rules="allRules"
                      label="Template name"/>
                      <v-layout>
                        <v-select
                          v-model="indexSelect"
                          :items="index_list"
                          :rules="allRules"
                          attach
                          chips
                          label="Choose Some Index"
                          multiple
                        >
                          <template slot="selection" slot-scope="data">
                            <v-chip color="#4478B7" :selected="data.selected" close @input="removeFilter(data.item)" text-color="#ccc">
                              <strong>{{data.item}}</strong>
                            </v-chip>
                          </template>
                        </v-select>
                      </v-layout>
                    <v-autocomplete
                      v-for="(item, index) in visualization"
                      v-model="item.value"
                      :items="mockUpChart"
                      :key="index"
                      :rules="allRules"
                      :label="'Select Visualization'"
                      perpend-icon="table_chart">
                      <v-slide-x-reverse-transition
                        slot="append-outer"
                        mode="out-in">
                        <v-icon
                          :color="'warning'"
                          @click="visualization.splice(index, 1)"
                          v-text="'delete'"/>
                      </v-slide-x-reverse-transition>
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout
                  align-center
                  justify-space-around>
                  <v-icon
                    @click="visualization.push({ value: '' })">
                    playlist_add
                  </v-icon>
                </v-layout>
                <v-layout>
                    <v-spacer></v-spacer>
                      <v-btn :key="item" @click="theSliceAdvanced()">
                        <v-icon>arrow_forward</v-icon>
                      </v-btn>
                </v-layout>
              </v-container>
            </v-card>
          </v-form>
        </v-flex>
      </v-layout>
      <v-layout v-else>
        <v-flex lg12 md12>
          <v-form
            ref="form"
            v-model="validForm"
            lazy-validation
          >
            <v-card dark>
              <v-toolbar flat>
                <v-btn @click="back()" icon>
                  <v-icon>arrow_back</v-icon>
                </v-btn>
                <v-toolbar-title>{{type}}</v-toolbar-title>
              </v-toolbar>
              <v-subheader style="padding: 0px 24px;">List Dashboard Template</v-subheader>
              <v-container grid-list-md fluid>
                <v-layout>
                  <v-list three-line class="text-md-left">
                    <template v-for="item in items">
                      <v-list-tile :key="item.title" class="box">
                        <v-flex pr-3>
                          <img style="width: 100px; height: 100px;"
                            :src="item.avatar" />
                        </v-flex>
                        <v-list-tile-content>
                          <v-list-tile-title v-html="item.title"></v-list-tile-title>
                          <v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-btn :key="item" @click.native="showDialogSelectChart = true" class="button-box">
                          <v-icon>arrow_forward</v-icon>
                        </v-btn>
                        <v-dialog v-model="showDialogSelectChart" max-width="500px">
                          <v-card dark>
                            <v-toolbar flat>
                              <v-toolbar-title>Select Your Index</v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-btn @click.native="showDialogSelectChart = false" icon>
                                <v-icon>close</v-icon>
                              </v-btn>
                            </v-toolbar>
                            <v-progress-linear
                              height="6px"
                              style="margin: 0"
                              :active="isLoading"
                              :indeterminate="isLoading"
                              absolute bottom
                              color="deep-purple accent-4"
                              />
                            <v-card-text>
                              <v-layout>
                                <v-flex lg12 md12>
                                  <v-autocomplete
                                    v-for="(item, index) in indexSelectList"
                                    v-model="item.value"
                                    :items="index_list"
                                    :key="index"
                                    :rules="allRules"
                                    :label="'Select Index'"
                                    perpend-icon="table_chart">
                                    <v-slide-x-reverse-transition
                                      slot="append-outer"
                                      mode="out-in">
                                      <v-icon
                                        :color="'warning'"
                                        @click="indexSelectList.splice(index, 1)"
                                        v-text="'delete'"/>
                                    </v-slide-x-reverse-transition>
                                  </v-autocomplete>
                                </v-flex>
                              </v-layout>
                              <v-layout
                                align-center
                                justify-space-around>
                                <v-icon
                                  @click="indexSelectList.push({ value: '' })">
                                  playlist_add
                                </v-icon>
                              </v-layout>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn :key="item" @click="theSlice(item)">Submit</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-list-tile>
                      <v-divider :key="item" :inset="true"/>
                    </template>
                  </v-list>
                </v-layout>
              </v-container>
            </v-card>
          </v-form>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-layout>
</template>

<script>
import axios from 'axios'

export default {
  name: 'DashboardDialogCreateNewTemplate',
  components: {
  },
  props: {
    index_list: {
      type: Array
    },
    user_inst: {
      type: String
    }
  },
  data: () => ({
    isLoading: false,
    showTemplateDetail: false,
    showDialogSelectChart: false,
    type: '',
    slice: [],
    addname: '',
    items: [],
    templateName: '',
    visualization: [{
      value: ''
    }],
    indexSelectList: [{
      value: ''
    }],
    mockUpChart: [],
    validForm: true,
    allRules: [
      v => !!v || 'This is required'
    ],
    fortigate: 'https://firewall.news/wp-content/uploads/2017/08/Fortinet-logo.png',
    indexSelect: ''
  }),
  async created () {
  },
  methods: {
    async selectType (method) {
      this.isLoading = true
      if (method === 'Advanced') {
        await axios.get(apiUrl + '/api/dashboard/getMockupChartName')
        .then(response => {
          this.mockUpChart = response.data.mockName
          this.isLoading = false
        }).catch(e => {
          this.isLoading = false
          alert(e.response.data.errmsg)
        })
      } else {
        await axios.post(apiUrl + '/api/dashboard/getTemplateName', {
          'source': 'description',
          'category': method
        }).then(response => {
          this.items = response.data.description
          this.isLoading = false
        }).catch(e => {
          alert(e.response.data.errmsg)
          this.isLoading = false
        })
      }
      this.showTemplateDetail = true
      this.type = method
    },
    back () {
      this.showTemplateDetail = false
    },
    async theSlice (method) {
      if (this.$refs.form.validate()) {
        this.isLoading = true
        let indexlist = this.indexSelectList.map(item => item.value)
        await axios.post(apiUrl + '/api/dashboard/slicesData', {
          'source': 'Other',
          'index': indexlist,
          'template': method.title,
          'instance': this.user_inst
        }).then(response => {
          this.slice = response.data.slice
          this.isLoading = false
        }).catch(e => {
          alert(e.response.data.errmsg)
          this.isLoading = false
        })
        this.addname = method.title
        this.showTemplateDetail = false
        this.$emit('commits', this.slice, this.addname)
      }
    },
    async theSliceAdvanced () {
      if (this.$refs.form.validate()) {
        this.isLoading = true
        // console.log(this.indexSelect)
        let chartList = this.visualization.map(item => item.value)
        await axios.post(apiUrl + '/api/dashboard/slicesData', {
          'source': 'Advanced',
          'index': this.indexSelect,
          'chartList': chartList
        }).then(response => {
          this.slice = response.data.slice
          this.isLoading = false
        }).catch(e => {
          alert(e.response.data.errmsg)
          this.isLoading = false
        })
        this.addname = this.templateName
        this.showTemplateDetail = false
        this.$emit('commits', this.slice, this.addname)
      }
    },
    removeFilter (item) {
      this.indexSelect.splice(this.indexSelect.indexOf(item), 1)
      this.indexSelect = [...this.indexSelect]
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
  .button-class {
    width: 100px;
    height: 100px;
  }
  .box {
    height: 115px;
    overflow: auto;
  }
  .button-box {
    height: 100%
  }
  .v-toolbar__extension {
    width: 100%;
    margin: 0;
    padding: 0;
    height: 7px;
  }
</style>



// WEBPACK FOOTER //
// src/components/DashboardDialogCreateNewTemplate.vue